(ns ycweb.app.dashboard.presence
  (:require
   [ajax.core :as ajax]
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtc]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]])
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.markdown.html :as m.html]
   [ycweb.util.markdown.parse :as markdown]
   [ycweb.util.sound :as sound]))


;; TODO: Order/YCS notes integration

;; TODO: Investigate 'outside borders' messages - YC4643379 as example.
;; TODO: integrate order notes from freshdesk
;; TODO: make letter links for email letters sent

;; TODO: linking a new person to a context just shows '@' until you refresh.
;; TODO: Bug in linking that doesn't show info of linked person.

;; TODO: Better 'sending' visibility

;; TODO: Attachments filter?
;; TODO: Presence Dashboard overview blocks.

;; TODO: Link to other entities (YC, YCS, YCR, Products)
;; TODO: Enforce chat message limit on client side (4k max)

;; TODO: Convert a message into a task by assigning it to someone

;; TODO: Permissions: If page doesn't have permission, don't allow chat for the page either.

;; TODO: System messages (proper 'robot' icon)
;; TODO: Message limits (only load the last 50(?) messages, 'load more' if there is more)


;; TODO: Phase 2
;; TODO: Pull staff images from BambooHR
;; TODO: Pull staff roles from BambooHR, display under names.

;; TODO Optimizations:
;; TODO: On window focus, mark as read without needing to scroll.
;; TODO: presence-chat-messages "Warning: Each child in a list should have a unique "key" prop. on load"
;; TODO: Debounce the message 'seen' checks and bundle them 100ms _after_ scroll has settled.

(rum/defc user-image-block < rum/static [user status config]
  (let [{:keys [ent/image ent/display-name] :as u} user
        hsh (if (:ent/uuid u) (mod (hash (:ent/uuid u)) 10) 5)]
    (cond
      (u/presence (:doc/public-id image))
      [:img.avatar
       {:class
        (u/bem :admin-user-image
          [(case status
             nil nil
             (:active :me) :is-active
             :removed :is-removed
             :is-inactive)]),
        :src
        (u/cloudinary (:doc/public-id image)
          {:h (or (:h config) 95)
           :w (or (:w config) 95)
           :q "auto"
           :f "auto"
           :avatar? true})
        :title display-name}]
      :else
      [:div
       {:title display-name
        :class
        (u/bem :missing-avatar
          [(keyword (str/format "%02d" hsh))]
          :admin-missing-avatar
          [(case status
             (:active :me) :is-active
             :removed :is-removed
             :is-inactive)])}
       [:div.missing-avatar__text
        (str (first display-name))]])))

;; Cross-cutting presence API.
(defn presence-context-cursor [app-atom uid]
  (rum/cursor-in app-atom [:presence :contexts uid]))

(defn presence-context-lookup-cursor [app-atom lookup]
  (let [lookup-ref
        (cmn/curact app-atom [:presence :lookup lookup])]
    (presence-context-cursor app-atom lookup-ref)))

(defn presence-lookup-cursor [app-atom lookup]
  (rum/cursor-in app-atom [:presence :lookup lookup]))

(defmethod comms/receive :presence/notify [app-atom e]
  (let [grouped
        (->>
          (:data e)
          (group-by :presence/context))]
    (swap! app-atom update :presence
      (fn [p]
        (->
          p
          (update :lookup merge (:lookup e))
          (update :contexts
            (fn [c]
              (->>
                c
                (map
                  (fn [[k v]]
                    (let [found (get grouped k)]
                      [k
                       (if found
                         (assoc v :active-users found)
                         v)])))
                (into {})))))))))


(defmethod t/transition-open :presence/dashboard [app-atom _ _]
  (dcommon/kill-search-bar))

(defmethod comms/receive :presence/open [app-atom e]
  (let [context-uuid (:ent/uuid (:context e))]

    (swap! app-atom update-in [:presence]
      (fn [p]
        (->
          (if (= (:open-context p) (:initial-context e))
            (assoc p :current-context context-uuid)
            p)
          (assoc-in [:lookup (:initial-context e)] (:ent/uuid (:context e)))
          (update-in [:lookup] merge (:lookup e)))))

    (swap!
      (presence-context-cursor app-atom context-uuid)
      (fn [c]
        (->
          c
          (assoc :context (:context e))
          #_(assoc :active-users (:active-users e))
          (assoc :presence (:presence e))
          (assoc :messages
            (->>
              (:messages e)
              (map (fn [[k v]] [k (update v :message/date-sent dtc/to-date-time)]))
              (into {}))))))))

(defmethod comms/receive :presence/close [app-atom e]
  (let [context-uuid (:ent/uuid (:context e))]
    (swap! app-atom update :presence
      (fn [p]
        (->
          p
          (update :lookup dissoc context-uuid)
          (update :current-context
            #(if (= context-uuid %) nil %)))))))

(defmethod comms/receive :presence/subscribe [app-atom e]
  (let [context-atom (presence-context-cursor app-atom (:context e))]
    (swap! context-atom update :presence merge (:presence e))))


#_(rum/defc presence-widget < rum/reactive [app-atom lookup-ref]
    (let [lookup-atom (rum/cursor-in app-atom [:presence :lookup])
          context-atom (presence-context-lookup-cursor app-atom lookup-ref)
          context (rum/react context-atom)]

      [:div
       (for [{:keys [ent/uuid presence/status]} (:active-users context)]
         (let [{:keys [user/publicID ent/display-name]} (cmn/curact lookup-atom [uuid])]
           [:span {:key uuid}
            (u/user-profile-pic
              {:public-id publicID :name display-name}
              {:w 32 :h 32} "avatar  image  image--full")]))]))



(rum/defc dashboard [app-atom]
  [:div
   [:h3 "Welcome to your Presence Dashboard"]
   [:button
    {:on-click #(t/transition-next app-atom :presence/chat)}
    "Chat"]])

(defmethod flow/render-screen :presence/dashboard [app-atom _]
  (dashboard app-atom))

(defmethod t/transition-open :presence/chat [app-atom _ _]
  (dcommon/kill-search-bar)
  (comms/send :presence/open
    {:context
     {:context/ident :presence/chat}}))

(defmethod t/transition-close :presence/chat [app-atom]
  (comms/send :presence/close
    {:context
     {:context/ident :presence/chat}}))

#_(rum/defc chatmessage-view < rum/static {:key-fn (fn [a m s] (str (:ent/uuid m)))}
    [app-atom message sender]
    (let [{:message/keys [text date-sent status] :as m} message]
      [:div
       [:div {:style {:float "left" :margin-right "5px"}}
        (u/user-profile-pic
          {:public-id (:doc/public-id (:ent/image sender)) :name (:user/display-name sender)}
          {:w 32 :h 32} "avatar  image  image--full")]
       #_(str (:ent/display-name sender) " - " date-sent " - " (pr-str status))
       [:span
        text]]))



#_(rum/defc chatmessage-window
    < rum/reactive cmn/cursors
    {:after-render
     (fn [state]
       #?(:cljs
          (let [node (js/ReactDOM.findDOMNode (:rum/react-component state))]
            (when node
              (js/setTimeout
                #(set! (.-scrollTop node) (.-scrollHeight node))
                100))))
       state)}
    [app-atom messages-atom]

    [:div {:style {:height "600px" :overflow "scroll"}}
     (for [message
           (->>
             (rum/react messages-atom)
             (vals)
             (sort-by (comp dtc/to-date-time :message/date-sent) dt/before?))]
       [:div  (:message/text message)]
       #_(chatmessage app-atom message))])


(rum/defc chat < cmn/cursors rum/reactive
  [app-atom context-ref]
  (let [context-atom (presence-context-lookup-cursor app-atom context-ref)]
    [:div
     [:h2 "Chat."]]))


(defmethod flow/render-screen :presence/chat [app-atom _]
  (chat app-atom {:context/ident :presence/chat}))


(defmethod grid/action :presence/submit-chat
  [app-atom config]

  (let [user (:user @app-atom)
        attachments (vec (vals (:message/attachment (:message config))))
        attachments
        (when (pos? (count attachments))
          (if (u/presence (:message/text (:message config)))
            attachments
            (update-in attachments [0] assoc :message/link (:message/link (:message config)))))
        message
        (update config :message assoc
          :ent/uuid (u/rand-uuid)
          :message/status {:db/ident :message.status/sending}
          :message/date-sent (dt/now)
          :message/attachment attachments)
        context-atom (presence-context-cursor app-atom (:ent/uuid (:context config)))
        msg (:message message)]

    (when
      (or
        (u/presence (:message/text (:message message)))
        (pos? (count attachments)))

      (swap! context-atom update-in [:messages]
        (fn [msgs]
          (->
            (u/maybe assoc
              (or msgs {})
              (:ent/uuid msg)
              (when (u/presence (:message/text msg))
                (assoc
                  (:message message)
                  :message/sender (u/uuid (:uuid user))
                  :message/seen-by #{(u/uuid (:uuid user))}
                  :message/link
                  (map :ent/uuid (:message/link msg)))))

            (into
              (map
                (fn [a]
                  [(:ent/uuid a)
                   (assoc a
                     :message/status {:db/ident :message.status/sending}
                     :message/sender (u/uuid (:uuid user))
                     :message/seen-by #{(u/uuid (:uuid user))}
                     :message/date-sent (dt/now)
                     :message/link
                     (map :ent/uuid (:message/link a)))])
                attachments)))))

      (comms/send :presence/submit-chat message))))

(defmethod comms/receive :presence/receive-chat [app-atom e]
  (swap! app-atom update :presence
    (fn [p]
      (let [messages
            (->>
              (:messages e)
              (map #(update % :message/date-sent dtc/to-date-time))
              (group-by :message/context))
            with-lookup
            (update-in p [:presence :lookup] merge (:lookup e))

            me-uuid (u/uuid (get-in @app-atom [:user :uuid]))
            current-messages
            (get-in p [:contexts (:current-context p) :messages])

            notification-messages
            (->>
              (get messages (:current-context p))
              (filter
                #(and
                   ;; Not received before
                   (not (contains? current-messages (:ent/uuid %)))
                   ;; Not me
                   (not (= me-uuid (:message/sender %)))
                   ;; Not seen by me
                   (not (contains? (:message/seen-by %) me-uuid)))))]
        #?(:cljs
           (when
             (and
               (not (.hasFocus js/document))
               (not (empty? notification-messages)))
             (sound/play :plop)))

        (reduce
          (fn [p [ctxuuid mlist]]
            (update-in p [:contexts ctxuuid :messages] merge
              (u/index-by :ent/uuid mlist)))
          with-lookup
          messages)))))


(defmethod comms/receive :presence/message-seen
  [app-atom {:keys [user message]}])

(defmethod grid/action :presence/read-all
  [app-atom {:keys [context]}]
  (let [presence-atom (presence-context-cursor app-atom (:ent/uuid context))
        me-uuid (u/uuid (:uuid (:user @app-atom)))
        messages
        (->>
          (:messages @presence-atom)
          (vals)
          (remove #(= (:db/ident (:message/status %)) :message.status/sending))
          (remove #(contains? (:message/seen-by %) me-uuid))
          (map :ent/uuid))]

    (swap! presence-atom update :messages
      (fn [m]
        (reduce
          #(update-in %1 [%2 :message/seen-by] (fnil conj #{}) me-uuid)
          m
          messages)))

    (comms/send :presence/message-seen
      {:messages messages})))

(defmethod grid/action :presence/message-pin
  [app-atom {:keys [message pinned?]}]
  (swap! app-atom assoc-in
    [:presence :contexts (:message/context message) :messages (:ent/uuid message) :message/pinned]
    pinned?)
  (comms/send :presence/message-pin
    {:message {:ent/uuid (:ent/uuid message)}
     :pinned? pinned?}))

(defmethod comms/receive :presence/message-pin
  [app-atom {:keys [message pinned?]}])

(defmethod grid/action :presence/open-chat
  [app-atom {:keys [context-uuid]}]
  (let [context-atom (presence-context-cursor app-atom context-uuid)]
    (swap! context-atom assoc :chat/status
      {:open? true
       :minimised? false})))

(rum/defcs presence-inline-users
  < rum/reactive
  {:will-mount
   (fn [state]
     (let [[app-atom context-atom] (:rum/args state)]
       (assoc state ::unseen-messages
         (rum/derived-atom
           [(rum/cursor-in app-atom [:user :uuid]) (rum/cursor-in context-atom [:messages])]
           :unseen-count
           (fn [user-uuid messages]
             #?(:cljs
                (let [user-uuid (u/uuid user-uuid)
                      current-title (.-title js/document)
                      current-title
                      (when current-title
                        (str/replace current-title #"^[(][0-9*]+[)]\s*" ""))
                      msg-count
                      (->>
                        messages
                        (vals)
                        (remove #(contains? (:message/seen-by %) user-uuid))
                        (count))]
                  (when current-title
                    (set! (.-title js/document)
                      (if (pos? msg-count)
                        (str "(" msg-count ") " current-title)
                        current-title)))
                  msg-count)))))))}

  [s app-atom context-atom]
  (let [lookup-atom (rum/cursor-in app-atom [:presence :lookup])

        [me others] (u/separate #(= (:presence/status %) :me) (cmn/curact context-atom [:active-users]))
        me (first me)

        unseen-messages
        (rum/react (::unseen-messages s))

        max-others 6
        active-users
        (->>
          others
          (sort-by (comp #(if (= % :active) 0 1) :presence/status)))

        open-fn
        #(do
           #?(:cljs
              (.preventDefault %))
           (grid/dispatch-action app-atom :presence/open-chat {:context-uuid (:ent/uuid (:context @context-atom))}))]
    [:div.admin-nav__users
     {:on-click open-fn}
     (into
       [:ul.admin-active-users]

       (concat
         (for [{:keys [presence/user presence/status]}
               (concat (take max-others active-users) (when me [me]))]
           (let [{:keys [ent/image ent/display-name] :as u} (cmn/curact lookup-atom [user])
                 hsh (if (:ent/uuid u) (mod (hash (:ent/uuid u)) 10) 5)]
             [:li
              {:key (:ent/uuid u)
               :class
               (u/bem :admin-active-users__item
                 [(when (= :me status) :is-you)])}
              [:a.admin-user-image-wrapper
               {:href "#"
                :title display-name
                :on-click open-fn}
               (user-image-block u status {})]]))

         [[:li
           {:data-others-count (count others)
            :data-others-count-less-displayed (max 0 (- (count others) max-others))
            :class
            (u/bem :admin-active-users__item
              [(when (and unseen-messages (pos? unseen-messages)) :has-new-message)
               (when (> (count others) 0) :has-more-users)])}


           [:a.admin-user-image-wrapper.js-admin-chat-open-button
            {:on-click open-fn}
            [:div.missing-avatar.u-bg-black
             {:class (u/bem :admin-missing-avatar [:is-chat])}
             [:div.missing-avatar__text [:i {:class (u/bem :icon [:user-chat :is-light :block])}]]]]]]))]))

(rum/defc presence-chat-header < rum/reactive
  [app-atom context-atom chat-status scroll-fn]
  (let [alter-status
        (fn [k status & kstat-pairs]
          (fn [e]
            (swap! context-atom assoc-in [:chat/status k] status)

            ;; TODO: Bit of a hack - look into not doing multiple swaps.
            (doseq [[k status] (partition 2 kstat-pairs)]
              (swap! context-atom assoc-in [:chat/status k] status))))]
    [:header.admin-chat-header
     [:h2.admin-chat-header__title
      (str
        (if (:changelog-view? chat-status) "Changelog: " "Chat: ")
        (cmn/curact context-atom [:context :ent/display-name]))]
     [:nav.admin-chat-header__actions
      [:a
       {:class (u/bem :admin-chat-header__button [:close])
        :on-click (alter-status :open? false)}
       [:i
        {:class (u/bem :icon [:close :is-dark :medium :block])}
        [:span.u-hidden-from-view "Close chat"]]]

      (if (:minimised? chat-status)
        [:a
         {:class (u/bem :admin-chat-header__button [:minimise])
          :on-click (alter-status :minimised? false)}
         [:i
          {:class (u/bem :icon [:plus :is-dark :medium :block])}
          [:span.u-hidden-from-view "Maximise chat"]]]

        [:a
         {:class (u/bem :admin-chat-header__button [:minimise])
          :on-click (alter-status :minimised? true)}
         [:i
          {:class (u/bem :icon [:minus :is-dark :medium :block])}

          [:span.u-hidden-from-view "Minimise chat"]]])

      [:div.admin-chat-header__button-wrapper.context-menu-wrapper
       [:a
        {:class (u/bem :admin-chat-header__button [:options]),
         :on-click (alter-status :menu-open? (not (:menu-open? chat-status)))}
        [:i
         {:class (u/bem :icon [:dots-menu :is-light :medium :block])}
         [:span.u-hidden-from-view "Options"]]]

       [:ul.context-menu
        {:class (u/bem :context-menu [(when (:menu-open? chat-status) :is-open)])}
        [:li.context-menu__item
         [:a.context-menu__link
          {:on-click
           (fn [e]
             ((alter-status
                :pinned-only? (not (:pinned-only? chat-status))
                :menu-open? false) e)
             (scroll-fn e))}
          (if (:pinned-only? chat-status)
            "Show all"
            "Show pinned items only")]]

        [:li.context-menu__item
         [:a.context-menu__link
          {:on-click
           (fn [e]
             ((alter-status :menu-open? false) e)
             (scroll-fn e)
             (grid/dispatch-action app-atom :presence/read-all {:context {:ent/uuid (:ent/uuid @context-atom)}}))}
          "Mark all as read"]]

        [:li.context-menu__item
         [:a.context-menu__link
          {:on-click
           (fn [e]
             ((alter-status
                :menu-open? false) e)
             (comms/send :presence/subscribe
               {:context (:ent/uuid (:context @context-atom))
                :subscribed? (not (:presence/subscribed (:presence @context-atom)))}))}
          (if (cmn/curact context-atom [:presence :presence/subscribed])
            "Unsubscribe from this chat"
            "Subscribe to this chat")]]

        [:li.context-menu__item
         [:a.context-menu__link
          {:on-click
           (fn [e]
             ((alter-status
                :changelog-view? (not (:changelog-view? chat-status))
                :menu-open? false) e)
             (when (not (:changelog-view? chat-status))
               (grid/dispatch-action app-atom :dashboard.presence/changelog {:context (:context @context-atom)}))
             (scroll-fn e))}
          (if (:changelog-view? chat-status)
            "Chat"
            "Changelog")]]]]]]))


(defn date-text [today yesterday dt & [time?]]
  (str
    (cond
      (ud/same-day? today dt) "Today"
      (ud/same-day? yesterday dt) "Yesterday"
      :else
      (ud/format-date dt
        (if time?
          "dd MMM"
          "dd MMMM YYYY")))
    (if time?
      (str " " (ud/format-date dt "HH:mm"))
      "")))

(rum/defc chat-date < rum/static [date]
  [:div.admin-chat-date
   [:span.admin-chat-date__text {:class (u/bem :text-pill [:dark :default])}
    date]])

(defmethod grid/action :presence/reply [app-atom {:keys [message sender]}]
  (let [context-atom (presence-context-cursor app-atom (:message/context message))]
    (swap! context-atom
      (fn [c]
        (->
          c
          (assoc :reply-to (:ent/uuid message))
          (update :links (fnil conj #{}) sender))))))

(rum/defc chat-message-block
  < rum/static
  [app-atom today yesterday messages sender]
  [:article
   {:class
    (u/bem :admin-chat-message
      [(when (:user/isMe sender) :is-you)
       (when (:user/system sender) :is-system)])
    :key (str (:ent/uuid (first messages)))}

   [:div.admin-chat-message__user
    (if (:user/system sender)
      [:div.admin-chat-message__missing-avatar.missing-avatar.u-bg-pink
       [:div.missing-avatar__text
        [:i {:class (u/bem :icon [:medium :robot :is-light :block])}]]]
      (user-image-block sender nil {}))]

   (into
     [:div.admin-chat-message__content]
     (->>
       messages
       (map
         (fn [message]
           [:div.js-admin-chat-message__block
            {:key (:ent/uuid message)
             :data-uuid (:ent/uuid message)
             :class
             (u/bem
               (if (:doc/public-id message)
                 :admin-chat-message__attachment
                 :admin-chat-message__text)
               [(when (:message/pinned message) :is-pinned)])}

            [:div.admin-chat-message__meta
             [:b (:ent/display-name sender)]
             (str " @ "
               (ud/format-date (:message/date-sent message) "HH:mm")
               (when-not (ud/same-day? today (:message/date-sent message))
                 (str "  on " (date-text today yesterday (:message/date-sent message))))

               (when (:message/reply-to message)
                 (str " (replied to " (get-in message [:message/reply-to :message/sender :ent/display-name]) ")")))]
            (when-not (empty? (:links message))
              (into
                [:p]
                (map-indexed
                  (fn [idx l]
                    ^{:key (str (or (:ent/uuid l) idx))}
                    [:span.admin-chat-message__mention
                     (str "@ " (:ent/display-name l))]))
                (:links message)))

            (when (u/presence (:message/text message))
              (into [:div.admin-chat-message__markdown]
                (markdown/parse (:message/text message))))

            (when (:doc/public-id message)
              [:img.admin-chat-message__image
               {:class (u/bem :yc-simple-image [:full])
                :src
                (u/cloudinary (:doc/public-id message)
                  {:w "full" :h 355 :q "auto" :f "auto"
                   :b "white" :c "lpad"})}])

            [:footer
             [:nav.admin-chat-message__options
              [:a.icon-link
               {:class (u/bem :icon-block-link [:size-small])
                :on-click
                #(grid/dispatch-action app-atom :presence/reply
                   {:message message :sender sender})
                :title "Reply to message"}
               [:i
                {:class (u/bem :icon [:reply :is-dark :medium :block])}
                [:span.u-hidden-from-view "Reply to message"]]]


              [:a
               {:class
                (u/bem
                  :icon-link [(when (:message/pinned message) :is-set)]
                  :icon-block-link [:size-small])
                :title (str (if (:message/pinned message) "Unpin" "Pin") " message")
                :on-click
                #(grid/dispatch-action app-atom :presence/message-pin {:message message :pinned? (not (:message/pinned message))})}
               [:i
                {:class
                 (u/bem :icon
                   [(if (:message/pinned message) :pin :pin-outline)
                    :is-dark :medium :block])}
                [:span.u-hidden-from-view
                 (str (if (:message/pinned message) "Unpin" "Pin") " message")]]]]


             (when (:doc/public-id message)
               [:div.admin-chat-message__zoom
                [:a.icon-link
                 {:class (u/bem :icon-block-link [:size-default])
                  :href
                  (u/cloudinary (:doc/public-id message)
                    {:w "full" :h "full" :f "auto" :q "full"})
                  :target "_blank"
                  :title "View original"}
                 [:i
                  {:class (u/bem :icon [:zoom :is-dark :block])}
                  [:span.u-hidden-from-view "View original"]]]])]]))))])


(defn chat-message
  [app-atom me-uuid today yesterday messages]
  (let [sender (rum/react (cmn/cursor-in app-atom [:presence :lookup (:message/sender (first messages))]))]

    (chat-message-block app-atom today yesterday
      (doall
        (map
          (fn [m]
            (assoc m
              :links
              (doall
                (map
                  (fn [l]
                    (rum/react (presence-lookup-cursor app-atom l)))
                  (:message/link m)))))
          messages))
      (if (= me-uuid (:ent/uuid sender))
        (assoc sender :user/isMe true)
        sender))))

;; TODO: Holding this around for reference,
;; But when the attachments and system messages are implemented, we can remove.
(def chat-data
  {:lookup
   {"jon"
    {:ent/image {:doc/public-id "users/75385_1551772707"}
     :ent/display-name "Jon Edwards"
     :user/isMe true}
    "ange"
    {:ent/image {:doc/public-id "users/125704_1548057262"}
     :ent/display-name "Angela Quinn"}
    "system"
    {:user/system true
     :ent/display-name "System"}}

   :messages
   [{:message/sender "ange"
     :message/text "Sup, Jon. Whatcha Doing."
     :message/date-sent (ud/parse-date "2020-09-08 07:27:32")}

    {:message/sender "jon"
     :message/text
     "I never in my life thought I'd be back here, designing a chat interface... The last time I did this — true story — was for the US government.

     It was in the Skype days, and this was kinda like Skype, but with different levels of security depending on your position in and branch of the armed forces."
     :message/date-sent (ud/parse-date "2020-09-08 07:47:32")}

    {:message/sender "jon"
     :doc/public-id "v1599492167/ui-demo-images/image-attachment-full-size.jpg"
     :message/date-sent (ud/parse-date "2020-09-08 07:48:32")}

    {:message/sender "ange"
     :message/pinned true
     :message/text
     "LOL! You're kidding, right?

     I mean, that seems highly unlikely and the kind of thing you'd make up to seem cool to people even though you're just a giant dork. No?"
     :message/date-sent (ud/parse-date "2020-09-08 07:48:42")}

    {:message/sender "system"
     :message/pinned true
     :message/system true
     :message/text
     "User role for Angela Quinn updated to Super-duper-admin."
     :message/date-sent (ud/parse-date "2020-09-16 07:49:32")}

    {:message/sender "jon"
     :message/text "Not really, no."
     :message/date-sent (ud/parse-date "2020-09-16 07:50:32")}

    {:message/sender "jon"
     :message/text
     "I worked for this tech company in the US, called BlueSpace. They've since become full-on goverment owned and they're now called BlueSpace Federal. But, yeah, this chat interface and — later I learned — I'd also helped design a drone deployment interface. For real.
      - For a start, this conversation is all in my head
      - Yup, I'm a little crazy, I know
      - Bear with me though, 'cause I've been working from home now since 15 March

      Let me break it down a little more for you…
      1. Currently, that's more than 175 days
         1. Indenting to test
             - More indenting
         2. More indenting.
      2. Currently, that's about 5 months and 3 weeks
      3. Which is almost half a year
      4. It's also been 6 full moon cycles so far"
     :message/date-sent (ud/parse-date "2020-09-16 09:43:32")}]})

(defn split-blocks-sender-recent [data]
  (loop [[b & bs] data
         acc {:acc [] :collect [] :last nil}]
    (cond
      (nil? b)
      (remove empty? (conj (:acc acc) (:collect acc)))

      (or
        (nil? (:last acc))
        (and
          (= (:message/sender (:last acc))
            (:message/sender b))
          (<=
            (dt/in-minutes
              (ud/interval
                (:message/date-sent (:last acc))
                (:message/date-sent b))) 5)))
      (recur bs
        (->
          acc
          (assoc :last b)
          (update :collect conj b)))

      :else
      (recur bs
        (->
          acc
          (update :acc conj (:collect acc))
          (assoc :collect [b] :last b))))))

(defn split-blocks-daily [data]
  (loop [[b & bs] data
         acc {:acc [] :collect [] :last nil}]

    (let [last-dt (:message/date-sent (:last acc))
          this-dt (:message/date-sent b)]

      (cond
        (nil? b)
        (remove empty?
          (conj (:acc acc) (:collect acc)))

        (or
          (nil? last-dt)
          (ud/same-day? last-dt this-dt))
        (recur bs
          (->
            acc
            (assoc :last b)
            (update :collect conj b)))

        :else
        (recur bs
          (->
            acc
            (update :acc conj (:collect acc))
            (assoc :collect [b] :last b)))))))

(def scroll-bottom
  {:will-mount
   (fn [state]
     (assoc state ::scroll (atom nil)))
   :did-mount
   (fn [state]
     #?(:cljs
        (let [node (js/ReactDOM.findDOMNode (:rum/react-component state))]
          (when node
            (js/setTimeout
              #(set! (.-scrollTop node) (.-scrollHeight node))
              100))))
     state)
   :before-render
   (fn [state]
     #?(:cljs
        (let [node (js/ReactDOM.findDOMNode (:rum/react-component state))]
          (cond
            (and
              node
              (<
                (-
                  (.-scrollHeight node)
                  (+ (.-clientHeight node) (.-scrollTop node)))
                5))

            (reset! (::scroll state) :bottom)

            :else
            (reset! (::scroll state) :ignore))))
     state)

   :after-render
   (fn [state]
     #?(:cljs
        (let [node (js/ReactDOM.findDOMNode (:rum/react-component state))]
          (when (and node (= :bottom @(::scroll state)))
            (set! (.-scrollTop node) (.-scrollHeight node)))))
     state)})

(defn check-seen [me-uuid context-atom chat-status state]
  (when (:open? chat-status)
    #?(:cljs
       (let [node (js/ReactDOM.findDOMNode (:rum/react-component state))
             [n-top n-bottom]
             (when node
               [(.-top (.getBoundingClientRect node))
                (.-bottom (.getBoundingClientRect node))])
             message-nodes
             (when node
               (seq (.getElementsByClassName node "js-admin-chat-message__block")))]
         (when (and (.hasFocus js/document) node)
           (doseq [m message-nodes]
             (let [m-top (.-top (.getBoundingClientRect m))
                   m-uuid (u/uuid (.getAttribute m "data-uuid"))
                   msg (get-in @context-atom [:messages m-uuid])]
               (when
                 (and
                   msg
                   (not= (:db/ident (:message/status msg)) :message.status/sending)
                   (not (contains? (:message/seen-by msg) me-uuid))
                   (> m-top n-top)
                   (< m-top n-bottom))

                 ;; So seen.
                 (comms/send :presence/message-seen
                   {:messages [(:ent/uuid msg)]})

                 (swap! context-atom update-in
                   [:messages m-uuid :message/seen-by]
                   #(set (conj % me-uuid)))))))))))

(defn message-blocks [messages]
  (->>
    messages
    (sort-by :message/date-sent dt/before?)

    (split-blocks-daily)
    (map split-blocks-sender-recent)))



(rum/defcs presence-chat-messages
  < scroll-bottom rum/reactive cmn/cursors
  {:after-render
   (fn [state]
     (let [[app-atom context-atom chat-status] (:rum/args state)]
       (check-seen (u/uuid (get-in @app-atom [:user :uuid]))
         context-atom chat-status state))
     state)}

  [state app-atom context-atom chat-status]
  (let [messages
        (->>
          (cmn/curact context-atom [:messages])
          (vals))
        messages
        (if (:pinned-only? chat-status)
          (filter :message/pinned messages)
          messages)
        blocks (message-blocks messages)

        today (dt/now)
        yesterday (dt/minus (dt/now) (dt/days 1))
        me-uuid (u/uuid (cmn/curact app-atom [:user :uuid]))]
    [:div.admin-chat-content-wrapper
     {:on-scroll
      (fn [e]
        (check-seen me-uuid context-atom chat-status state)
        state)}
     (into
       [:div.admin-chat-content
        (when (:older-messages? chat-status)
          [:div.admin-chat-archive-button
           [:a
            {:class (u/bem :button [:rounded :raised :small :muted])}
            "Load older messages"]])]


       (mapcat
         (fn [block]
           (let [dt (:message/date-sent (ffirst block))
                 date-str (date-text today yesterday dt)]
             (cons
               (rum/with-key
                 (chat-date date-str)
                 (str "date-" date-str "-" (:ent/uuid (ffirst block))))
               (map
                 (fn [messages]
                   (rum/with-key
                     (chat-message app-atom me-uuid today yesterday messages)
                     (str "msg-" (:ent/uuid (first messages)))))
                 block))))
         blocks))]))

(rum/defcs chat-input
  < rum/reactive
  {:after-render
   (fn [state]
     #?(:cljs
        (let [[val-atom open?] (:rum/args state)
              node (js/ReactDOM.findDOMNode (:rum/react-component state))]
          (add-watch val-atom ::clear-watch
            (fn [k r o n]
              (when (and (not= o n) (str/blank? n))
                (set!
                  (.-innerHTML node)
                  ""))))
          (when (and node open?)
            (.focus node))))
     state)}

  [s val-atom open? dispatch-function]
  [:div.admin-chat-nav__input
   {:contentEditable "true"
    :data-placeholder "Type your message"
    :on-input
    (fn [e]
      #?(:cljs
         (reset! val-atom
           (m.html/html->markdown
             (.-innerHTML
               (js/ReactDOM.findDOMNode (:rum/react-component s)))))))
    :on-key-down
    (fn [e _]
      (when
        (and (not (.-shiftKey e)) (== (.-keyCode e) 13))

        (when dispatch-function (dispatch-function))

        (.preventDefault e)))}])

(rum/defc link-options < rum/reactive
  [app-atom context-atom option-atom tp]
  (let [options (cmn/curact option-atom [:options])

        search-atom (rum/cursor option-atom [:search])
        search (rum/react search-atom)
        options
        (case tp
          :user
          (->>
            options
            (filter
              (if (zero? (count search))
                :shared-team?
                #(str/index-of
                   (str/lower-case (:ent/display-name %))
                   (str/lower-case search))))
            (take 14))
          :link
          options)
        selected-idx
        (min
          (dec (count options))
          (max
            0
            (or (cmn/curact option-atom [:select-idx]) 0)))]

    [:nav
     {:class (u/bem :admin-chat-mention-nav [:is-open])}
     [:ul.admin-chat-mention
      (map-indexed
        (fn [idx o]
          [:li.admin-chat-mention__item
           {:key (:ent/uuid o)
            :style (u/maybe assoc {:cursor "pointer"} :background-color (when (= idx selected-idx) "silver"))
            :on-mouse-over
            (fn [_]
              (swap! option-atom assoc :select-idx idx))}
           [:a.admin-chat-mention__link
            {:on-click
             #(grid/dispatch-action app-atom :presence/chat-link-select
                {:option-atom option-atom :option o
                 :context {:ent/uuid (:ent/uuid (:context @context-atom))}})}
            (when (:ent/image o)
              [:div.admin-chat-mention__user
               [:img.admin-chat-mention__avatar.avatar
                {:src (u/cloudinary (-> o :ent/image :doc/public-id) {:q "auto" :w 48 :h 48 :f "auto" :avatar? true})}]])
            [:div.admin-chat-mention__text
             (:ent/display-name o)
             (when (:ent/info o)
               [:i [:br] (:ent/info o)])]]])
        options)


      [:li.admin-chat-mention__item
       [:input
        (let [input-props
              (forms/input-props search-atom
                {:change-fn
                 (fn [_ _]
                   (swap! option-atom assoc :select-idx 0))})]
          (merge
            input-props
            {:type "text"
             :placeholder "Type a name"
             :class (u/bem :text-input [:mini])
             :autoFocus true
             :on-key-down
             (fn [e _]
               (cond
                 ; ESC
                 (== (.-keyCode e) 27)
                 (do
                   (swap! option-atom dissoc :mode)
                   (.preventDefault e))

                 ;; Enter
                 (== (.-keyCode e) 13)
                 (do
                   (grid/dispatch-action app-atom :presence/chat-link-select
                     {:option-atom option-atom :option (first (drop selected-idx options))
                      :context {:ent/uuid (:ent/uuid (:context @context-atom))}})
                   (.preventDefault e))

                 ;; Up
                 (== (.-keyCode e) 38)
                 (do
                   (swap! option-atom update :select-idx #(max (dec (or % 0)) 0))
                   (.preventDefault e))

                 ;; Down
                 (== (.-keyCode e) 40)
                 (do
                   (swap! option-atom update :select-idx #(min 14 (inc (or % 0)) (dec (count options))))
                   (.preventDefault e))))}))]]]]))

(defmethod grid/action :presence/chat-link-select
  [app-atom {:keys [context option option-atom]}]
  (when (:ent/uuid option)
    (let [{:keys [mode] :as o} @option-atom
          context-atom (presence-context-cursor app-atom (:ent/uuid context))]
      (reset! option-atom {})
      (swap! context-atom update :links (fnil conj #{}) option))))

(rum/defc chat-options [option-atom options select-fn]
  (let [selected-idx
        (min
          (dec (count options))
          (max
            0
            (or (cmn/curact option-atom [:select-idx]) 0)))]
    [:nav
     {:class (u/bem :admin-chat-mention-nav [:is-open])}
     [:ul.admin-chat-mention
      (->>
        options
        (map-indexed
          (fn [idx o]
            [:li.admin-chat-mention__item
             {:key (str (:type o))
              ;; TODO: need to figure out how to dispatch up/down keys to here...
              #_#_:style (u/maybe assoc {} :background-color (when (= idx selected-idx) "silver"))}

             [:a.admin-chat-mention__link
              {:style {:cursor "pointer"}
               :on-click #(select-fn % o)}
              [:div.admin-chat-mention__text
               (:text o)]]])))]]))

;; Ick. But besides having to weave in a context path, this is going to have to do.
(defonce current-option-atom (atom nil))

(defmethod grid/action :presence/chat-menu-select
  [app-atom {:keys [context option option-atom]}]
  (println "Selected option: " option)
  (reset! current-option-atom option-atom)

  (case (:type option)
    :user
    (do
      (reset! option-atom {:mode :user :search ""})
      (comms/send :presence/chat-menu-search-users {:context context :search ""}))

    :link
    (do
      (reset! option-atom {:mode :link :search ""})
      (comms/send :presence/chat-menu-search-links {:context context :search ""}))
    nil))



(defmethod comms/receive :presence/chat-menu-search-users
  [app-atom {:keys [context search users]}]
  (let [option-atom @current-option-atom]
    (swap! option-atom assoc :options users)))

(defmethod comms/receive :presence/chat-menu-search-links
  [app-atom {:keys [context search links]}]
  (let [option-atom @current-option-atom]
    (when (= search (:search @option-atom))
      (swap! option-atom assoc :options links))))

(defn upload-file
  [{:keys [file filecontents filename] :as file}
   {:keys [response callback callback-error]} attachment-uuid context-uuid]
  #?(:cljs
     (let [form-data
           (doto
             (js/FormData.)
             (.append "file" file)
             (.append "uuid" (str attachment-uuid))
             (.append "context-uuid" (str context-uuid)))
           ws-msg
           {:context-uuid (str context-uuid)
            :uuid (str attachment-uuid)
            :file
            {:type (:type file)
             :filename filename
             :filecontents filecontents
             :response response}}]
       (cond
         filecontents
         (comms/send :presence/upload-attachment ws-msg)

         :else
         (ajax/POST
           (str "/api/presence/upload-attachment")
           {:body form-data
            :response-format :json
            :keywords? true
            :handler callback
            :error-handler callback-error
            :timeout 60000})))))

(defmethod grid/action :presence/upload-file
  [app-atom {:keys [context-atom e]}]
  #?(:cljs
     (let [context (:context @context-atom)
           attachment-uuid (u/uuid)
           file
           (first
             (-> e
               .-target
               .-files
               array-seq))

           callback-fn
           (fn [res]
             (if (:success res)
               (swap! context-atom
                 (fn [c]
                   (cond
                     (contains? (:attachments c) attachment-uuid)
                     (update c :attachments assoc attachment-uuid res)

                     (contains? (:messages c) attachment-uuid)
                     (update c :messages attachment-uuid merge res))))
               (toaster/open-toast app-atom :error (str "File upload failed") {})))

           callback-error-fn
           (fn [res]
             (toaster/open-toast app-atom :error (str "File upload failed: " (:msg res)) {}))]
       (swap! context-atom update :attachments assoc
         attachment-uuid
         {:ent/uuid attachment-uuid
          :uploading? true})
       (upload-file
         {:file file}
         {:callback callback-fn
          :callback-error callback-error-fn}
         attachment-uuid
         (:ent/uuid context)))))

(defmethod grid/action :presence/remove-file
  [app-atom {:keys [context-atom] :as file}]
  (let [context (:context @context-atom)]
    (comms/send :presence/remove-attachment
      {:ent/uuid (:ent/uuid file)
       :response :presence/remove-attachment})
    (swap! context-atom update :attachments dissoc (:ent/uuid file))))

(defmethod comms/receive :presence/remove-attachment [app-atom e]
  (when (not (:success e))
    (toaster/open-toast app-atom :error "Failed to remove image" {})))

(defn scroll-fn [scroll-component-state & [e]]
  #?(:cljs
     (let [node (js/ReactDOM.findDOMNode (:rum/react-component scroll-component-state))
           message-scrollable
           (when node
             (first (seq (.getElementsByClassName node "js-admin-chat-content-wrapper"))))]
       (when message-scrollable
         (js/setTimeout
           #(set! (.-scrollTop message-scrollable) (.-scrollHeight message-scrollable))
           100))

       (when e
         (.preventDefault e)))))

(rum/defcs chat-input-block < rum/reactive (cmn/local {:value ""} ::local)
  [s app-atom context-atom chat-status scroll-component-state]
  (let [val-atom (rum/cursor-in (::local s) [:value])
        option-atom (rum/cursor-in (::local s) [:option])
        links (cmn/curact context-atom [:links])
        attachments (cmn/curact context-atom [:attachments])
        dispatch-function
        (fn [& [e]]
          (let [context @context-atom]
            (cond
              (not-empty (filter :uploading? (:attachments context)))
              (toaster/open-toast app-atom :error
                "Please wait for attachments to finish uploading before sending your message."
                {})

              :else
              (do
                (grid/dispatch-action app-atom :presence/submit-chat
                  {:context {:ent/uuid (:ent/uuid (:context context))}
                   :message
                   {:message/text @val-atom
                    :message/link (:links context)
                    :message/reply-to (:reply-to context)
                    :message/attachment (:attachments context)}})
                (reset! val-atom nil)
                (swap! context-atom dissoc :links :attachments)
                (scroll-fn scroll-component-state e)))))

        ;; Sadly, this is needed because of the way file upload component
        ;; needs to be found on the DOM and triggered as a 'click'.. quite silly.
        menu-select-fn
        (fn [e o]
          (cond
            (= (:type o) :file)
            #?(:cljs
               (let [node (js/ReactDOM.findDOMNode (:rum/react-component s))
                     file-upload (first (.getElementsByClassName node "js-file-upload"))]
                 (.click file-upload))
               :clj
               nil)

            :else
            (grid/dispatch-action app-atom :presence/chat-menu-select
              {:option o
               :option-atom option-atom
               :context {:ent/uuid (:ent/uuid (:context @context-atom))}})))]
    [:form.admin-chat-nav
     [:input.js-file-upload.u-hidden-from-view
      {:type "file"
       :on-change
       #(do
          (swap! option-atom update :mode (fn [e] (if e nil :menu)))
          (grid/dispatch-action app-atom :presence/upload-file {:context-atom context-atom :e %}))}]
     [:div.admin-chat-nav__button-wrapper
      [:label.icon-link
       {:class (u/bem :admin-chat-nav__button [:attachment] :icon-block-link [:size-small])
        :on-click
        (fn [e]
          (swap! option-atom update :mode #(if % nil :menu))
          #?(:cljs
             (.preventDefault e)))}

       [:i
        {:class (u/bem :icon [:attachment :is-dark :block])}
        [:span.u-hidden-from-view "Upload attachment"]]]]

     [:div.admin-chat-nav__input-wrapper
      (when-not (empty? links)
        [:div.admin-chat-nav__mention-preview
         (map
           (fn [l]
             [:span.admin-chat-nav__mention-pill
              {:class (u/bem :text-pill [:has-shadow :dark :medium])}
              (str "@ " (:ent/display-name l))
              [:a.text-pill__close-button
               {:on-click #(swap! context-atom update :links disj l)}
               [:i
                {:class (u/bem :icon [:close :is-light :block :medium])}
                [:span.u-hidden-from-view "Remove mention"]]]])
           links)])

      (chat-input val-atom (:open? chat-status) dispatch-function)

      (case (cmn/curact option-atom [:mode])
        :menu
        (chat-options
          option-atom
          [{:text "File" :type :file}
           {:text "User" :type :user}
           #_{:text "Client Order" :type :clientorder}
           #_{:text "Stock Order" :type :stockorder}
           #_{:text "Product" :type :product}]
          menu-select-fn)

        :user
        (link-options app-atom context-atom option-atom :user)
        :link
        (link-options app-atom context-atom option-atom :link)

        nil)
      (when-not (empty? attachments)
        [:div.admin-chat-nav__attachment-preview
         (map
           (fn [[u a]]
             [:article.admin-chat-nav__attachment-item
              [:img.admin-chat-nav__attachment-image

               {:src
                (u/cloudinary
                  (:doc/public-id a)
                  {:h 64
                   :w 64
                   :q "auto"
                   :f "auto"}) :alt (:doc/file-name a)}]
              [:a.admin-chat-nav__attachment-cancel
               {:on-click #(grid/dispatch-action app-atom :presence/remove-file {:context-atom context-atom :ent/uuid u})}
               [:i
                {:class (u/bem :icon [:close :is-light :medium :block])}
                [:span.u-hidden-from-view "Cancel file upload"]]]])
           attachments)])]

     [:div.admin-chat-nav__button-wrapper
      [:button.icon-link
       {:class (u/bem :admin-chat-nav__button [:send] :icon-block-link [:size-small]),
        :type "submit"
        :on-click dispatch-function}
       [:i
        {:class (u/bem :icon [:send :is-dark :block])}
        [:span.u-hidden-from-view "Send message"]]]]]))

(rum/defc changelog-view < rum/reactive [app-atom context-atom filter-atom]
  (let [{:keys [history entity lookup]} (cmn/curact context-atom [:changelog])
        today (dt/now)
        yesterday (dt/minus (dt/now) (dt/days 1))
        filter-value (str/lower-case (rum/react filter-atom))

        render-txblock
        (fn [txes]
          (let [[_ _ inst author uri] (first txes)]
            [:article.admin-chat-message
             [:div.admin-chat-message__user
              [:img.avatar.admin-user-image
               {:src
                (u/cloudinary (:doc/public-id (:ent/image author))
                  {:h 32
                   :w 32
                   :q "auto"
                   :f "auto"
                   :avatar? true})
                :title (:ent/display-name author)}]]
             [:div.admin-chat-message__text
              [:div.admin-chat-message__meta
               [:b
                (:ent/display-name author)]
               " "
               (str (date-text today yesterday inst true))]


              [:table.u-margin-top-10
               (for [[attr rf] txes]
                 [:tr
                  [:td [:b (str (:ent/display-name attr) ":")]]
                  [:td (str rf)]

                  #_[:td {:style {:font-size "8px"} :width "50px"} (str uri)]])]

              [:p
               {:style
                {:font-family "Courier" :font-size "10px" :color "silver"}}
               (str uri)]]]))]

    (into
      [:div]

      (->>
        history
        (map
          (fn [[a v inst au uri txid]]
            (let [author (get lookup au)
                  attr (get lookup a)
                  rf
                  (if (= (get-in attr [:db/valueType :db/ident]) :db.type/ref)
                    (get-in lookup [v :ent/display-name])
                    v)]
              [attr rf (dtc/from-date inst) author uri txid])))

        (filter
          (fn [[attr rf inst author uri]]
            (if (u/presence filter-value)
              (or
                (str/includes? (str/lower-case (:ent/display-name attr)) filter-value)
                (str/includes? (str/lower-case (str rf)) filter-value)
                (str/includes? (str/lower-case (:ent/display-name author)) filter-value)
                (str/includes? (str/lower-case uri) filter-value))
              true)))

        (partition-by (fn [[_ _ i _ _ _]] (ud/format-date i "dd MMMM YYYY")))

        (mapcat
          (fn [dttx]
            (let [[_ _ inst _ _] (first dttx)]
              ;; TODO: add a live date and group changelogs per day like chat does
              (concat
                [[:div.admin-chat-date
                  [:span.admin-chat-date__text {:class (u/bem :text-pill [:dark :default])}
                   (date-text today yesterday inst)]]]

                (->>
                  dttx
                  (partition-by (fn [[_ _ _ _ _ txid]] txid))
                  (map render-txblock))))))))))

(rum/defcs changelog < rum/reactive (cmn/local {} ::local) [s app-atom context-atom chat-status]
  (let [val-atom (rum/cursor-in (::local s) [:value])
        dispatch-function (fn [e] (.preventDefault e) (println "loading."))]
    (list
      [:form.admin-chat-nav
       [:div.admin-chat-nav__input-wrapper
        ;; TODO: struggling to make changes to this input. Can this be made to look like the chat input? The logic is a bit beyond me.
        [:input.admin-chat-nav__input
         (merge
           {:placeholder "Filter changelog"}
           (forms/input-props
             val-atom
             {}
             #_{:change-fn (fn [e v] (println "Change: " v))
                :submit-fn (fn [v] (println "Submit: " v))}))]]

       [:div.admin-chat-nav__button-wrapper
        [:button.icon-link
         {:class (u/bem :admin-chat-nav__button [:search] :icon-block-link [:size-small]),
          :type "submit"
          :on-click dispatch-function}
         [:i
          {:class (u/bem :icon [:search :is-dark :block])}
          [:span.u-hidden-from-view "Filter"]]]]]
      [:div.admin-chat-content-wrapper
       [:div.admin-chat-content
        [:div.admin-chat-archive-button
         [:a
          {:class (u/bem :button [:rounded :raised :small :muted])
           :on-click #(grid/dispatch-action app-atom :dashboard.presence/changelog {:context (:context @context-atom)})}
          "Refresh"]]
        (changelog-view app-atom context-atom val-atom)]])))

(defmethod grid/action :dashboard.presence/changelog [app-atom e]
  (toaster/open-subtle-progress app-atom)
  (comms/send :dashboard.presence/changelog
    {:context {:ent/uuid (:ent/uuid (:context e))}}))

(defmethod comms/receive :dashboard.presence/changelog [app-atom e]
  (toaster/close-toast app-atom)
  (let [context-atom (presence-context-cursor app-atom (:context-uuid e))]
    (swap! context-atom assoc :changelog
      (select-keys e [:entity :history :lookup]))))




(rum/defcs presence-chat-widget
  < rum/reactive
  [s app-atom context-atom]
  (let [chat-status (cmn/curact context-atom [:chat/status])]

    [:div
     (into
       [:section
        {:class
         (u/bem :admin-chat
           [(when (:minimised? chat-status) :is-minimised)
            (when (:open? chat-status) :is-open)])}

        (presence-chat-header app-atom context-atom chat-status scroll-fn)]
       (if (:changelog-view? chat-status)
         [(changelog app-atom context-atom chat-status)]
         [(presence-chat-messages app-atom context-atom chat-status)
          (chat-input-block app-atom context-atom chat-status s)]))]))

(rum/defc presence-inline-widget < rum/reactive [app-atom]
  (let [current-context (cmn/curact app-atom [:presence :current-context])
        context-atom (presence-context-cursor app-atom current-context)]
    (cond
      (nil? current-context) [:div.admin-nav__users "Loading..."]

      :else
      (rum/fragment
        {:key context-atom}
        (presence-inline-users app-atom context-atom)
        (presence-chat-widget app-atom context-atom)))))

;; This should only be called when you _don't_ want a presence widget on the page
;; Else simply call 'open'
(defn close [app-atom ident]
  (swap! app-atom update :presence dissoc :current-context :open-context))

(defn open [app-atom ident]
  (swap! app-atom update :presence assoc :open-context ident))

(defn connection-listener [app-atom state]
  (when state
    (let [contexts (keys (get-in @app-atom [:presence :contexts]))]
      (doseq [context-uuid contexts]
        (comms/send :presence/open
          {:context {:ent/uuid context-uuid}})))))

(rum/defcs presence-inline-chat
  < rum/reactive cmn/cursors
  (cmn/local {:pinned? false} ::local)
  [s app-atom context-uuid &
   [{:keys [width height overflow]}]]
  (when (u/presence context-uuid)
    (let [local-atom (::local s)
          context-atom (presence-context-cursor app-atom context-uuid)
          current-context (cmn/curact app-atom [:presence :current-context])
          chat-status (cmn/curact context-atom [:chat/status])]
      [:div
       (into
         [:section.u-margin-bottom-12
          {:class
           (u/bem :admin-chat [:is-inline])
           :style
           {:max-width (or width "600px")
            :height (or height "500px")}}]
         (if (:changelog-view? chat-status)
           [(changelog app-atom context-atom chat-status)]
           [(presence-chat-messages app-atom context-atom {:pinned-only? (cmn/curact local-atom :pinned?)})
            (chat-input-block app-atom context-atom (atom {:open? true}) s)]))
       [:div
        {:class (u/bem :flex-grid-group [:align-left])}
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (forms/toggle "Pinned" (rum/cursor local-atom :pinned?)
            {:small? true})]]
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (forms/toggle "Changelog"
            (rum/cursor-in context-atom [:chat/status :changelog-view?])
            {:small? true
             :change-fn #(grid/dispatch-action app-atom :dashboard.presence/changelog {:context (:context @context-atom)})})]]]])))

(defn attribute [node attr]
  (when node
    (.getAttribute node (str "data-" attr))))

(defn open-inline-node [app-atom lref]
  (let [opened (get-in @app-atom [:presence :opened])]
    (swap! app-atom assoc-in [:presence :current-context] (or (:ent/uuid lref) (:ent/ident lref)))
    (when-not (contains? opened lref)
      (swap! app-atom update-in [:presence :opened] (fnil conj #{}) lref)
      (comms/send :presence/open
        {:context lref}))))

(defn mount-inline-node [app-atom e]
  (let [context-uuid (attribute e "context-uuid")
        context-type (attribute e "context-type")
        context-ident (attribute e "context-ident")

        lref
        (if context-uuid
          {:ent/uuid (u/uuid context-uuid) :context/type (when context-type (keyword context-type))}
          {:context/ident (when context-ident (keyword context-ident))})]

    (open-inline-node app-atom lref)

    (rum/mount (presence-inline-chat app-atom (u/uuid context-uuid)) e)))




(defn setup-presence-widget [app-atom]
  #?(:cljs
     (let [presence-node (.getElementById js/document "presence-react-mount")

           context-uuid (attribute presence-node "context-uuid")
           context-ident (attribute presence-node "context-ident")
           context-type (attribute presence-node "context-type")

           _ (cmn/release-cursor-in app-atom [:presence :current-context])

           context
           (u/maybe assoc
             {}
             :ent/uuid (when context-uuid (u/uuid context-uuid))
             :context/type (when context-type (keyword context-type))
             :context/ident (when context-ident (keyword context-ident)))]

       ;; Note: Be wary of this. There may some implications of auto-open/close when composing
       ;; multiple active presence on a single page.
       (add-watch app-atom ::open-context
         (fn [k r o n]
           (let [old-open-context (get-in o [:presence :open-context])
                 new-open-context (get-in n [:presence :open-context])]
             (when (not= old-open-context new-open-context)
               (when old-open-context
                 (swap! app-atom update-in [:presence :opened] (fnil disj #{}) old-open-context)
                 (comms/send :presence/close
                   {:context old-open-context}))

               (when new-open-context
                 (let [opened (get-in @app-atom [:presence :opened])]
                   (when-not (contains? opened new-open-context)
                     (swap! app-atom update-in [:presence :opened] (fnil conj #{}) new-open-context)
                     (comms/send :presence/open
                       {:context new-open-context}))))))))

       (set! (.-presenceOpenChat js/window)
         (fn [context-uuid]
           (grid/dispatch-action app-atom :presence/open-chat {:context-uuid (u/uuid context-uuid)})))

       (doseq [e (seq (.getElementsByClassName js/document "presence-inline-mount"))]
         (mount-inline-node app-atom e))

       (when presence-node
         (rum/mount (presence-inline-widget app-atom) presence-node)

         (when (or (:context/ident context) (:ent/uuid context))
           (open app-atom context)))



       (comms/register-connection-listener #'connection-listener))))
